export default "__VITE_ASSET__CzLUPyz2__"